import React from 'react';
import { useTranslation } from '@lt/localization';

import styles from './searchParamsLabel.module.css';

const SearchParamsLabel = () => {
  const { t } = useTranslation();
  return <span className={styles.label}>{t('checkout.search.change')}</span>;
};

export default SearchParamsLabel;
